import { render, staticRenderFns } from "./VerificationSign.vue?vue&type=template&id=beae4e02&scoped=true"
import script from "./VerificationSign.vue?vue&type=script&lang=ts"
export * from "./VerificationSign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beae4e02",
  null
  
)

export default component.exports